module.exports = __webpack_public_path__ + "media/notification.a85c8c44.wav";